const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export function isUuidLike(value: string | null | undefined): boolean {
  return UUID_PATTERN.test(String(value ?? "").trim());
}

export function resolveProfileDisplayName(
  rawValue: string | null | undefined,
  namesById?: Map<string, string>,
  unknownLabel = "Unassigned",
): string {
  const normalized = String(rawValue ?? "").trim();
  if (!normalized) return unknownLabel;
  if (!isUuidLike(normalized)) return normalized;
  return namesById?.get(normalized) ?? unknownLabel;
}
